import React from 'react';
import './ErrorMessage.css';

function ErrorMessage({ message }) {
  return (
    <div className="error-container">
      <div className="error-icon">⚠️</div>
      <h2>Unable to Load Appointment</h2>
      <p>{message}</p>
      <div className="error-suggestions">
        <p><strong>What you can do:</strong></p>
        <ul>
          <li>Check if the appointment link is correct</li>
          <li>Verify your internet connection</li>
          <li>Try refreshing the page</li>
          <li>Contact support if the issue persists</li>
        </ul>
      </div>
    </div>
  );
}

export default ErrorMessage;
